// extracted by mini-css-extract-plugin
export var orderSummary = "_pv-0";
export var showMoreLessButton = "_pv-1";